module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [(_vm.$route.name == 'brandTable') ? _c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/crBrand'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("\n            新增品牌\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default btn-table-title",
    attrs: {
      "disabled": _vm.show.isDownloading
    },
    on: {
      "click": function($event) {
        return _vm.exportFile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n          下載報表\n          "), _c('clip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.isDownloading),
      expression: "show.isDownloading"
    }],
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.show.isDownloading,
      "color": '#528BB8',
      "size": '16px'
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-6 col-sm-6 text-right"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchResult),
      expression: "searchResult"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchResult)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchResult = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.clickPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchResult),
      expression: "searchResult"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchResult)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchResult = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.clickPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("品牌")]), _vm._v(" "), _c('th', [_vm._v("名稱（ID）")]), _vm._v(" "), (_vm.show.brand) ? _c('th', [_vm._v("縮寫")]) : _vm._e(), _vm._v(" "), (!_vm.show.menuDetail) ? _c('th', [_vm._v("代碼(鍵值)")]) : _vm._e(), _vm._v(" "), (_vm.show.brand && _vm.getRoleType === 99) ? _c('th', [_vm._v("\n              門市數量\n              "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('th', [_vm._v("狀態")]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('th', [_vm._v("前端")]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('th', [_vm._v("刪除狀態")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("你訂聯盟")]), _vm._v(" "), (_vm.show.brand && _vm.getRoleType === 99) ? _c('th', [_vm._v("群組")]) : _vm._e(), _vm._v(" "), (_vm.show.brand && _vm.getRoleType !== 10 && _vm.getRoleType !== 50) ? _c('th', [_vm._v("廣告")]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('th', [_vm._v("店家")]) : _vm._e(), _vm._v(" "), (!_vm.show.history && !_vm.show.menu && !_vm.show.menuDetail && _vm.getRoleType !== 10 && _vm.getRoleType !== 50) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('th', [_vm._v("店家")]) : _vm._e(), _vm._v(" "), (_vm.show.activity) ? _c('th') : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(3)]) : (_vm.brandList.length) ? _c('tbody', _vm._l((_vm.brandList), function(brand, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": _vm.webDomain + 'brand/' + brand.brand_code,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-brand-table",
      attrs: {
        "src": brand.image_name
      }
    })])]), _vm._v(" "), _c('td', [(_vm.show.brand) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/brandInfo/' + brand.id
        }
      }
    }, [_vm._v("\n              " + _vm._s(brand.name) + " (" + _vm._s(brand.id) + ")\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.show.brand) ? _c('span', [_vm._v("\n              " + _vm._s(brand.name) + " (" + _vm._s(brand.id) + ")\n            ")]) : _vm._e()], 1), _vm._v(" "), (_vm.show.brand) ? _c('td', [_vm._v("\n            " + _vm._s(brand.name_short) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.show.menuDetail) ? _c('td', [_vm._v("\n            " + _vm._s(brand.brand_code) + "(" + _vm._s(brand.brand_key) + ")\n          ")]) : _vm._e(), _vm._v(" "), (_vm.show.brand && _vm.getRoleType === 99) ? _c('td', [_vm._v("\n            " + _vm._s(brand.store_amount || 0) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('td', [(brand.is_opening) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("\n              已上架\n            ")]) : _vm._e(), _vm._v(" "), (!brand.is_opening) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("\n              未上架\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('td', [(brand.is_visible) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("\n              顯示\n            ")]) : _vm._e(), _vm._v(" "), (!brand.is_visible) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("\n              隱藏\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show.brand || _vm.show.history) ? _c('td', [(!brand.is_delete) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("\n              未刪除\n            ")]) : _vm._e(), _vm._v(" "), (brand.is_delete) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("\n              刪除\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', _vm._l((brand.nidin_league_levels), function(level, index) {
      return (brand.nidin_league_levels.length) ? _c('span', {
        key: index,
        class: level === 1 ? 'label label-primary mr-1' : 'label label-warning mr-1'
      }, [_vm._v("\n              " + _vm._s(level === 1 ? '等級一' : '等級二') + "\n            ")]) : _c('span', [_vm._v("\n              -\n            ")])
    }), 0), _vm._v(" "), (_vm.show.brand && _vm.getRoleType === 99) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/groupTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-object-group"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.brand && _vm.getRoleType !== 10 && _vm.getRoleType !== 50) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/brandAdTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-file-image-o"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.brand) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/storeTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-home"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.history) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/storeHistoryTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-home"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.brand && _vm.getRoleType !== 10 && _vm.getRoleType !== 50) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/upBrand/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/brandMenu/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-plus-square"
    }), _vm._v("\n                配料庫\n              ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/brandMenuTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-wrench"
    }), _vm._v("\n                菜單建置\n              ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/storeTable/productImage/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-picture-o"
    }), _vm._v("\n                圖片庫\n              ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/storeTable/productSetting/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-certificate"
    }), _vm._v("\n                別名 / 描述 / 警語\n              ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/cupDiscountTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default flex align-center "
    }, [_c('img', {
      attrs: {
        "src": require("../../../../assets/icon/i_reusable_cup_black.svg")
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-center"
    }, [_vm._v("自備飲料杯管理")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/brandScheduleTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v("\n                排程\n              ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.menuDetail) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'StoreMenu',
          params: {
            brand_id: brand.id,
          },
          query: {
            back_page: _vm.tableIndex
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-home"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.activity) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/activityScheduleTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    })])])], 1) : _vm._e(), _vm._v(" "), (_vm.show.schedule) ? _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/brandScheduleTable/' + brand.id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    })])])], 1) : _vm._e()])
  }), 0) : (_vm.brandList.length === 0) ? _c('tbody', [_vm._m(4)]) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "brandPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n            名稱\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n            名稱\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text alliance-tooltip"
  }, [_vm._v("\n                  統計該品牌下目前營業中且可被搜尋到的門市總數\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("\n              資料讀取中...\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("\n                沒有符合的資料\n              ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63ce7f9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Brand/Temp/BrandTableTemp.vue
// module id = 2454
// module chunks = 1